<div class="steps-panel" *ngIf="steps && steps.length > 0">
  <div *ngFor="let step of steps; let i = index" class="step-section" [class.step-primary]="i + 1 == currentStep" 
    [class.step-success]="i + 1 < currentStep">
    <div class="step-number-container">
      <div class="step-line"></div>
      <span *ngIf="i + 1 >= currentStep" class="step-number">{{ i + 1 }}</span>
      <i *ngIf="i + 1 < currentStep" class="fas fa-check"></i>
      <div class="step-line"></div>
    </div>
    <span class="step-description">{{ step }}</span>
  </div>
</div>
